import {useTranslation} from "react-i18next";
import "./Services.css"
import useAnimation from "../../utils/hooks/animate";
import {useEffect, useState} from "react";
import {NavLink as NavLinkR} from "reactstrap";
import ContactModal from "../../components/ContactModal";

export const Services = () => {
    const {t} = useTranslation();
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: t("services")});
    }, [t]);

    const [showModal, setShowModal] = useState(false);

    return (
        <main className="pt-2">
            <section>
                <p className="text-center animated">{t('tarifs.p.1')}</p>
                {/*<a target="_blank" rel="noreferrer" className="d-flex justify-content-center" href="https://t.me/Busines09575Bot">/!*{t('tarifs.p.2')}*!/{t('telegram.bot')}</a>*/}
                <NavLinkR className="other d-flex justify-content-center link-primary" href=""
                          onClick={(e) => {
                              e.preventDefault();
                              setShowModal(true);
                          }}>
                    {t('contacts.form.open')}
                </NavLinkR>
                <ContactModal type={'TARIFS'} show={showModal} onHide={() => setShowModal(false)}/>
            </section>
            <section>
                <p className="text-center animated">{t('hire.p.1')}</p>
                {/*<a target="_blank" rel="noreferrer" className="d-flex justify-content-center" href="https://t.me/Busines09575Bot">{t('telegram.bot')}</a>*/}
                <NavLinkR className="other d-flex justify-content-center link-primary" href=""
                          onClick={(e) => {
                              e.preventDefault();
                              setShowModal(true);
                          }}>
                    {t('contacts.form.open')}
                </NavLinkR>
                <ContactModal type={'HIRE'} show={showModal} onHide={() => setShowModal(false)}/>
            </section>
        </main>
    );
};